import { render, staticRenderFns } from "./uploadAnyFile.vue?vue&type=template&id=12ffb763&scoped=true"
import script from "./uploadAnyFile.vue?vue&type=script&lang=js"
export * from "./uploadAnyFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ffb763",
  null
  
)

export default component.exports